import axios from "axios";
import store from "../store/index";
var dispose = {};
dispose.setDisposition = async function(callItem, nextCall, sipCallId = null) {
  const contact = { ...callItem };

  // Include SIP Call-ID if available
  if (sipCallId) {
    contact.sipCallId = sipCallId;
    contact.defaultDialer = "PBX Dialer"; // Set dialer type for reports
    console.log("📹 Including SIP Call-ID in disposal:", sipCallId);
  }

  // Log the contact being disposed for debugging
  console.log("📋 [DISPOSER] Disposing contact:", {
    contactId: contact.id,
    phone: contact.phone,
    listId: contact.listId,
    called: contact.called,
    dispo: contact.dispo,
    storeSelectedList: store.state.selectedList
  });

  // Use contact's listId if available, fallback to store's selectedList
  const effectiveListId = contact.listId || store.state.selectedList;
  
  if (contact.listId !== store.state.selectedList) {
    console.warn("⚠️ [DISPOSER] List ID mismatch! Contact listId:", contact.listId, "Store selectedList:", store.state.selectedList, "Using:", effectiveListId);
  }

  const response = await axios.post(
    `${store.state.ENDPOINT}/contacts/dispose`,
    {
      contact: contact,
      type: "call",
      returnNextCall: nextCall,
      listId: effectiveListId, // Use effective list ID
      dialerAction: "place_call",
      v: 3,
    },
    {
      headers: {
        Authorization: `${store.state.user.token}`,
      },
    }
  );

  // Log the response for debugging
  console.log("✅ [DISPOSER] Disposition response:", {
    success: !!response.data,
    contactIdFromResponse: response.data && response.data.contact && response.data.contact.id,
    calledStatus: response.data && response.data.contact && response.data.contact.called,
    sipRecordingLinked: response.data && response.data.sipRecordingLinked
  });

  // Check if SIP recording was linked during disposal
  if (response.data && response.data.sipRecordingLinked) {
    console.log("✅ SIP recording automatically linked during disposal");
  }

  return response;
};
export default dispose;
